<div *ngIf="data" id="summary-route" class="summary-route">
    <div class="summary-route__item">
        <i class="pi pi-map-marker icon"></i>
        <span class="value">
            {{ data.distance | distance }}
        </span>
        <span class="title">
            {{'distance'|translate}}
        </span>
    </div>
    <div class="summary-route__item">
        <i class="pi pi-angle-up icon"></i>
        <span class="value">
            {{ data.time }}
        </span>
        <span class="title">
            {{'driveTime'|translate}}
        </span>
    </div>
    <div class="summary-route__item">
        <i class="pi pi-flag icon"></i>
        <span class="value">
            {{ data.stopTime }}
        </span>
        <span class="title">
            {{'reports.stopTime'|translate}}
        </span>
    </div>
    <div class="summary-route__item">
        <img class="icon-fuel" src="/assets/images/vehicles/fuel.svg" alt="">
        <span class="value">
            {{ data.fuel | fuel }} L
        </span>
        <span class="title">
            {{'fuelConsumed'|translate}}
        </span>
    </div>
    <div class="summary-route__item">
        <i class="pi pi-circle icon"></i>
        <span class="value">
            {{ data.fuelPer100 | fuel }} L/100km
        </span>
        <span class="title">
            {{'fuelConsumption'|translate}}
        </span>
    </div>
</div>
